// キャッチ設定モーダル
const ModalNoteTemplate = {
  namespaced: true,

  state: {
    modal: false,
  },
  getters: {
    getModal: state => {
      return state.modal
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
  },
  actions: {
    set({ commit }) {
      commit('setModal', true)
    },
    reset({ commit }) {
      commit('setModal', false)
    },
  },
}

export default ModalNoteTemplate
